{
  "errors": {
    "network": "Hálózati hiba. Kérjük, ellenőrizze a kapcsolatot és próbálja újra.",
    "unknown": "Hiba történt. Kérjük, próbálja újra.",
    "operationNotSupported": "A(z) '{{operation}}' művelet nem támogatott",
    "http": {
      "400": "Hibás kérés",
      "401": "Nincs jogosultság. Kérjük, jelentkezzen be újra.",
      "403": "Hozzáférés megtagadva",
      "404": "Nem található",
      "409": "Ez az elem már létezik",
      "422": "Érvényesítés sikertelen. Kérjük, ellenőrizze a bevitt adatokat.",
      "500": "Szerverhiba. Kérjük, próbálja újra később.",
      "503": "A szolgáltatás ideiglenesen nem elérhető"
    },
    "validation": {
      "required": "Ez a mező kötelező",
      "invalid": "Érvénytelen érték",
      "minLength": "Túl rövid",
      "maxLength": "Túl hosszú",
      "duplicate": "Már létezik",
      "email": "Érvénytelen e-mail cím",
      "password": "A jelszó nem felel meg a követelményeknek",
      "passwordsMismatch": "A jelszavak nem egyeznek",
      "failed": "Érvényesítés sikertelen",
      "selectPerson": "Kérjük, válasszon egy személyt",
      "selectOrgFunction": "Kérjük, válasszon egy funkciót",
      "selectSystem": "Kérjük, válasszon egy rendszert",
      "selectExternalContact": "Kérjük, válasszon egy külső kapcsolattartót",
      "fileRequired": "Kérjük, válasszon egy fájlt",
      "url": "Érvénytelen URL"
    },
    "department": {
      "duplicateAbbreviation": "A(z) '{{abbreviation}}' rövidítéssel már létezik osztály",
      "abbreviationAlreadyInUse": "A(z) '{{abbreviation}}' osztály rövidítés már használatban van",
      "abbreviationDuplicateInData": "Duplikált rövidítés: '{{abbreviation}}'",
      "nameAlreadyInUse": "A(z) '{{name}}' osztálynév már használatban van",
      "nameDuplicateInData": "Duplikált név: '{{name}}'",
      "notFound": "Osztály nem található",
      "parentNotFound": "Szülő osztály nem található",
      "selfParent": "Egy osztály nem lehet saját maga szülője",
      "circularDependency": "Nem lehet egy osztályt saját leszármazottja alá helyezni",
      "hasSubdepartments": "Alosztályokkal rendelkező osztály nem törölhető",
      "hasMembers": "Tagokkal rendelkező osztály nem törölhető",
      "noManager": "A következő osztályokhoz nincs menedzser rendelve: {{departments}}. Kérjük, rendeljen menedzsereket a folyamatok létrehozása előtt.",
      "alreadyResolved": "Ehhez az osztályhoz már hozzá van rendelve menedzser"
    },
    "orgFunction": {
      "notFound": "Funkció nem található",
      "mainRoleInvalidKind": "A pozíciónak pozíció típusú funkciónak kell lennie",
      "nameDuplicateInData": "Ismétlődő név ('{{name}}') található az adatokban",
      "nameAmbiguous": "A(z) '{{name}}' nem egyértelmű – ilyen néven funkció és csapat is létezik",
      "alreadyExists": "A(z) '{{name}}' már létezik, ezért kihagytuk"
    },
    "common": {
      "invalidId": "Érvénytelen azonosító"
    },
    "auth": {
      "invalidPassword": "Érvénytelen e-mail cím vagy jelszó. Kérjük, próbálja újra.",
      "passwordUnchanged": "Az új jelszavának különböznie kell a jelenlegi jelszavától.",
      "userNotFound": "Érvénytelen e-mail cím vagy jelszó. Kérjük, próbálja újra.",
      "unauthorized": "Nincs jogosultság. Kérjük, jelentkezzen be újra.",
      "noMembership": "Még nincs hozzáférése egyetlen munkaterülethez sem. Kérjen meghívót a rendszergazdájától.",
      "ssoRequired": "Ez a munkaterület egyszeri bejelentkezést (SSO) igényel. Kérjük, folytassa az e-mail címével, hogy a szervezetén keresztül jelentkezzen be.",
      "notZitadelLinked": "Fiókja még nincs összekapcsolva az identitásrendszerrel. Jelentkezzen be egyszer egyszeri bejelentkezéssel (SSO), vagy forduljon a rendszergazdához.",
      "reauthRequired": "Biztonsági okokból kérjük, jelentkezzen be újra a bejelentkezési beállítások módosítása előtt."
    },
    "sso": {
      "stateExpired": "A bejelentkezési munkamenet lejárt. Kérjük, próbálja újra.",
      "exchangeFailed": "A bejelentkezést nem sikerült befejezni. Kérjük, próbálja újra.",
      "transactionInvalid": "Ez a bejelentkezés csak abban a böngészőben fejezhető be, amelyben elindította. Kérjük, jelentkezzen be újra.",
      "emailMismatch": "A bejelentkezett fiók nem egyezik a megadott e-mail címmel. Kérjük, próbálja újra.",
      "emailUnverified": "Az e-mail-címe nincs megerősítve. Kérjük, erősítse meg a személyazonosság-szolgáltatójánál, majd próbálja újra."
    },
    "user": {
      "notFound": "Felhasználó nem található",
      "alreadyExists": "Már létezik fiók ezzel az e-mail-címmel ({{email}}).",
      "duplicateEmail": "A(z) '{{email}}' e-mail-címmel már létezik felhasználó ebben a szervezetben",
      "emailDuplicateInData": "Duplikált e-mail-cím: '{{email}}'",
      "invalidEmail": "Érvénytelen e-mail cím",
      "inactive": "A felhasználói fiók inaktív",
      "suspended": "Fiókja felfüggesztésre került. Kérjük, lépjen kapcsolatba a rendszergazdájával.",
      "alreadySuspended": "A felhasználói fiók már felfüggesztett",
      "alreadyActive": "A felhasználói fiók már aktív",
      "invalidStatus": "Érvénytelen felhasználói státusz",
      "alreadyHasCredentials": "Ez a személy már rendelkezik bejelentkezési adatokkal, és közvetlenül be tud jelentkezni – aktiválási linkre nincs szükség.",
      "emailChangeNotAllowed": "Ennek a személynek az e-mail-címe nem módosítható, mert ez a bejelentkezési azonossága. Ha módosítani kell, forduljon az ügyfélszolgálathoz.",
      "externalMemberNoDepartment": "Külső személyek nem rendelhetők osztályhoz",
      "externalMemberNoTeam": "Külső személyek nem rendelhetők funkcióhoz",
      "externalMemberRequiresRole": "A külső tagoknak legalább egy felhasználótípust kell kapniuk",
      "userTypesTenantTypeMismatch": "Ezek a szerepkörök nem léteznek ebben a szervezettípusban. A partnerszervezetek a partner-szerepköröket, az ügyfél- és demószervezetek az ügyfél-szerepköröket osztják ki.",
      "memberIsTeamLead": "Nem lehet külsővé átsorolni: a személy jelenleg funkcióvezető. Először távolítsa el funkcióvezetői pozíciójából.",
      "emailNotFound": "Nem található munkatárs a(z) '{{email}}' e-mail-címmel"
    },
    "partner": {
      "tenantRequired": "Ez a felület csak partnerszervezetek számára érhető el.",
      "adminRequired": "Ez a művelet a partner-adminok számára van fenntartva.",
      "memberRequiresRole": "A partnerszervezet tagjának partner-szerepkörre van szüksége.",
      "memberMustBeInternal": "A partnerszervezet tagjai a partnercég saját belső munkatársai.",
      "hubspotNotLinked": "Ez a partnerfiók még nincs HubSpot-céghez kapcsolva. Ezt a kapcsolatot Bliks-adminisztrátornak kell létrehoznia.",
      "salesNotActivated": "Ez a tag nincs értékesítésre aktiválva, így a leadnek nincs akvizitőre. Partner-admin a felhasználókezelésben tudja aktiválni.",
      "salesAlreadyActivated": "Ez a tag már aktiválva van értékesítésre.",
      "memberNotActive": "Ez a tag még nem fogadta el a meghívását. Az értékesítési aktiválás csak az első bejelentkezése után lehetséges.",
      "contactAlreadyLinked": "Ez a HubSpot-kapcsolat már egy másik taghoz van kötve.",
      "memberNoEmail": "A HubSpot-kapcsolat összekötéséhez e-mail-cím szükséges.",
      "contactNotAdoptable": "Ez a HubSpot-kapcsolat egy másik partnercéghez tartozik, ezért itt nem adható hozzá.",
      "materialNotFound": "Ez az anyag már nem létezik.",
      "materialFileNotFound": "Ehhez az anyaghoz nem tartozik fájl.",
      "materialUploadInvalid": "A feltöltés érvénytelen. Kérjük, töltse fel újra a fájlt.",
      "newsNotFound": "Ez a hír már nem létezik.",
      "newsImageInvalid": "A kép érvénytelen. Kérjük, töltse fel újra."
    },
    "role": {
      "selfRemovalForbidden": "A saját szerepkörét nem vonhatja vissza – ezzel elveszítené a hozzáférést, amivel visszavonhatná. Kérjen meg egy másik adminisztrátort erre a módosításra.",
      "lastHolderForbidden": "Ez az utolsó aktív adminisztrátor. Utána senki sem tudná kezelni a szervezet felhasználóit."
    },
    "recording": {
      "invalidStatusForAction": "Ez a művelet nem engedélyezett a rögzítés jelenlegi állapotában",
      "nameOrDescriptionRequired": "A rögzítés véglegesítéséhez név és leírás is szükséges",
      "userNotRecordingStep": "Ön nem rögzíti ezt a lépést",
      "nudgeTargetNotActive": "Ez a személy nem kaphat emlékeztetőt, mert a fiókja nem aktív",
      "decisionRuleNotFound": "Döntési szabály nem található",
      "decisionHasNoRules": "A döntésnek nincsenek meghatározott szabályai"
    },
    "process": {
      "notFound": "Folyamat nem található",
      "duplicateName": "A(z) '{{name}}' névvel már létezik folyamat",
      "invalidOperation": "Ez a művelet az aktuális állapotban nem engedélyezett"
    },
    "processEvent": {
      "notFound": "Az esemény nem található",
      "startRequired": "A folyamatnak szüksége van kezdőeseményre — nem távolítható el és nem alakítható át"
    },
    "processChain": {
      "notFound": "Folyamatlánc nem található",
      "circularDependency": "Nem hozható létre körkörös függőség a folyamatláncok között",
      "selfParent": "Egy folyamatlánc nem lehet saját szülője",
      "typeConflict": "Egy lánc nem tartalmazhat egyszerre alláncokat és folyamatokat."
    },
    "processConnection": {
      "notFound": "Folyamatkapcsolat nem található"
    },
    "processStep": {
      "notFound": "Folyamatlépés nem található"
    },
    "processDraft": {
      "notFound": "Ehhez a folyamathoz nincs piszkozat.",
      "alreadyExists": "Ehhez a folyamathoz már létezik piszkozat.",
      "publishContentValidation": "Néhány lépésből hiányzik a szükséges tartalom.",
      "publishGraphValidation": "Néhány lépés nincs csatlakoztatva.",
      "publishConflict": "A közzétett folyamat módosult szerkesztés közben.",
      "stepNotFound": "Piszkozat-lépés nem található.",
      "edgeNotFound": "Ez a kapcsolat már nem létezik a piszkozatban.",
      "deleteFailed": "Nem sikerült törölni — kérjük, próbálja újra.",
      "deletePartialFailure": "Néhány lépést nem sikerült törölni — kérjük, próbálja újra.",
      "deleteStaleSelection": "Ezek a lépések már törölve lettek.",
      "noteNotFound": "A jegyzet nem található.",
      "historyNotFound": "Ehhez a piszkozathoz nincs szerkesztési előzmény.",
      "insertNotApplicable": "Ez a lépés itt már nem szúrható be.",
      "eventInputNotLinkable": "Ehhez a bemenethez nem csatolható esemény.",
      "convertRequiresPreviousOutput": "Egy feladathoz legalább egy bejövő eredmény szükséges."
    },
    "organization": {
      "notFound": "Szervezet nem található"
    },
    "approval": {
      "notFound": "A jóváhagyás nem található",
      "notPending": "Ez a jóváhagyás már nem nyitott",
      "notReviewer": "Nem vagy kijelölve ehhez a jóváhagyáshoz",
      "ownRequest": "A saját kérésedet más hagyja jóvá",
      "alreadyDecided": "Már döntöttél",
      "reasonRequired": "Kérjük, adj meg indoklást",
      "overrideNotAllowed": "A szabály nem engedi a jóváhagyás nélküli folytatást",
      "notRequester": "Csak a kérelmező vonhatja vissza",
      "notAdmin": "Ezt csak a munkaterület adminisztrátorai tehetik meg"
    },
    "task": {
      "notFound": "A feladat nem található",
      "alreadyCompleted": "A feladat már nem nyitott",
      "assigneeNotFound": "A feladat felelőse nem található"
    },
    "assignment": {
      "notFound": "Hozzárendelés nem található",
      "alreadyCompleted": "A hozzárendelés már befejezve",
      "alreadyAcceptedByTeammate": "Ezt a feladatot már elfogadta a funkció egy másik betöltője. Köszönjük az elkötelezettségét.",
      "taskNotDefined": "A hozzárendelési feladat még nincs definiálva",
      "rulesNotDefined": "A hozzárendelési szabályok még nincsenek definiálva",
      "outputNotDefined": "A hozzárendelés kimenete kötelező",
      "alreadyFinished": "A hozzárendelés már befejezve",
      "reassigneeNotFound": "Az átadás célja nem található",
      "notExternalContact": "Ez a lépés nincs külső kapcsolattartóhoz rendelve",
      "recordingDelegateNotFound": "A kiválasztott személy nem található"
    },
    "merge": {
      "targetNotFound": "A célként megadott lépésrögzítés nem található.",
      "targetNotCompleted": "A célként megadott lépésrögzítés még nem fejeződött be.",
      "targetWrongProcess": "A célként megadott lépésrögzítés egy másik folyamathoz tartozik.",
      "userNotRelated": "Nincs kapcsolata ezzel a lépésrögzítéssel.",
      "sameNode": "Egy lépés nem vonható össze önmagával."
    },
    "system": {
      "notFound": "Rendszer nem található",
      "nameDuplicateInData": "Ismétlődő rendszernév ('{{name}}') található az adatokban",
      "alreadyExists": "A(z) '{{name}}' rendszer már létezik, ezért kihagytuk"
    },
    "artifact": {
      "notFound": "Dokumentum nem található"
    },
    "externalContact": {
      "notFound": "Külső kapcsolat nem található"
    },
    "tenant": {
      "notFound": "Bérlő nem található",
      "expired": "Szervezete hozzáférése lejárt. Kérjük, lépjen kapcsolatba a rendszergazdájával.",
      "cloneFailed": "Nem sikerült a bérlő duplikálása. A hiányos másolat megmaradhatott — a bérlőlistában elvethető.",
      "cloneDiscardRefused": "A duplikátum törlését egy biztonsági ellenőrzés elutasította, például mert a duplikálás mégis befejeződött, és a bérlő már nem ehhez a feladathoz tartozik, vagy mert a folyamata még fut. Semmi nem került törlésre.",
      "cloneInProgress": "A bérlőt érintő duplikálás jelenleg is folyamatban van. Kérjük, várja meg a befejezését, majd próbálja újra. A folyamatban lévő duplikálás nem szakítható meg.",
      "slugAlreadyInUse": "Ezt az azonosítót már használja egy másik bérlő. Kérjük, válasszon másikat.",
      "typeChangeStrandsMembers": "A szervezet típusa nem módosítható, amíg {{count}} tag a jelenlegi típus szerepköreit birtokolja. Előbb módosítsa ezeket a szerepköröket, vagy ürítse ki a szervezetet.",
      "hubspotCompanyAlreadyLinked": "Ez a HubSpot-vállalat már egy másik bérlőhöz van kapcsolva."
    },
    "appConfig": {
      "notConfigurable": "Ennek az alkalmazásnak nincsenek konfigurálható beállításai.",
      "invalid": "A konfiguráció nem felel meg annak, amit az alkalmazás elvár."
    },
    "seatLimit": {
      "systemAdminsReached": "A rendszergazdai helyek korlátja elérve ({{limit}} helyből {{current}} foglalt). Kérjük, függesszen fel vagy töröljön egy rendszergazdát, vagy kérje a korlát megemelését.",
      "orgManagersReached": "A szervezeti menedzseri helyek korlátja elérve ({{limit}} helyből {{current}} foglalt). Kérjük, függesszen fel vagy töröljön egy szervezeti menedzsert, vagy kérje a korlát megemelését.",
      "membersReached": "Az alapfelhasználói helyek korlátja elérve ({{limit}} helyből {{current}} foglalt). Kérjük, függesszen fel vagy töröljön egy alapfelhasználót, vagy kérje a korlát megemelését.",
      "appSeatsReached": "Ehhez az alkalmazáshoz {{limit}} hely tartozik, de {{requested}} felhasználót rendeltek hozzá. Kérjük, rendeljen hozzá kevesebb felhasználót, vagy kérje a korlát megemelését.",
      "appSeatOrgManagerNotSeatable": "A szervezeti menedzserek már minden alkalmazást elérnek, ezért nem foglalhatnak helyet. Kérjük, távolítsa el őket a hozzárendelésből, majd mentse újra."
    },
    "seatOverrun": "A szervezetben több felhasználó van, mint ahány hely rendelkezésre áll. Egy szervezeti menedzsernek vagy rendszergazdának fel kell függesztenie vagy törölnie kell egy felhasználót, mielőtt a módosítások menthetők lennének.",
    "initialSetup": {
      "alreadyCompleted": "A kezdeti beállítás már befejeződött, és nem futtatható újra.",
      "prerequisitesMissing": "Kérjük, először állítsa be az osztályokat és a munkatársakat",
      "notCompleted": "A szervezet kezdeti beállítása még nem fejeződött be. Módosítások csak ezt követően lehetségesek.",
      "updateNotAllowed": "Ez a bejegyzés itt már nem szerkeszthető. Kérjük, töltse újra az oldalt, és próbálja meg újra.",
      "removalBlocked": "Ez a bejegyzés nem törölhető, mert más bejegyzések hivatkoznak rá.",
      "incomplete": "Az első beállítás hiányos. Kérjük, pótolja a hiányokat a befejezés előtt."
    },
    "dataSync": {
      "syncRunNotFound": "Ez a szinkronizálás már nem létezik.",
      "syncRunInProgress": "Ebben a szervezetben már fut egy szinkronizálás. Kérjük, próbálja újra, ha az befejeződött.",
      "syncRunStale": "Ez a szinkronizálás befejezés előtt leállt. Kérjük, indítson új szinkronizálást.",
      "syncRunNotInReview": "Ez a szinkronizálás már nem alkalmazható. Kérjük, indítson új szinkronizálást.",
      "selectionInvalid": "Néhány kiválasztott módosítás így nem alkalmazható. Kérjük, ellenőrizze a kiválasztást, és próbálja újra.",
      "excelInvalidIds": "A fájl érvénytelen azonosítókat tartalmaz ({{rows}}). Kérjük, a letöltött fájl azonosítóit változatlanul hagyja.",
      "excelDuplicateEmails": "Több sornak ugyanaz az e-mail-címe ({{rows}}). Minden személynek saját e-mail-cím szükséges.",
      "excelDuplicateIds": "Több sornak ugyanaz az azonosítója ({{rows}}). Kérjük, töltse le az aktuális fájlt, és abban rögzítse a módosításait.",
      "excelUnknownIds": "A fájl olyan azonosítókat tartalmaz, amelyek a Bliksben nem léteznek ({{rows}}). Kérjük, töltse le az aktuális fájlt, és abban rögzítse a módosításait.",
      "excelMismatchedIds": "Ezek a sorok egy másik bejegyzés nevét viselik ({{rows}}). Kérjük, töltse le az aktuális fájlt, és abban rögzítse a módosításait. Ha egy bejegyzésnek egy olyan bejegyzés nevét szeretné adni, amelyet ez a fájl töröl, először a törlést töltse fel.",
      "excelDuplicateNames": "Több új sornak ugyanaz a neve ({{rows}}). Kérjük, adjon minden új bejegyzésnek saját nevet.",
      "excelNameMatchesSeveral": "Ezek az azonosító nélküli sorok olyan nevet viselnek, amely több meglévő bejegyzésé ({{rows}}). Kérjük, adja meg a szándékolt bejegyzés azonosítóját a letöltött fájl szerint.",
      "excelEmptyReferencedSheet": "A(z) {{sheet}} munkalapnak nincsenek sorai, de más sorok hivatkoznak a bejegyzéseire. Kérjük, vegye fel ezeket a bejegyzéseket a(z) {{sheet}} munkalapra, vagy ürítse ki a rájuk hivatkozó cellákat.",
      "excelAmbiguousNames": "Több sornak ugyanaz a neve, amelyre egy másik cella hivatkozik ({{rows}}). Kérjük, tegye egyedivé a neveket.",
      "excelUnresolvedReferences": "Ezek a sorok olyan osztályt vagy pozíciót neveznek meg, amely nem szerepel a fájlban ({{rows}}). Kérjük, vegye fel a(z) {{departmentsSheet}} vagy a(z) {{rolesSheet}} munkalapra, vagy javítsa a nevet.",
      "excelParentCycle": "Ezek az osztályok egymás felettes osztályai ({{rows}}). Kérjük, javítsa a felettes osztályokat.",
      "excelUnknownEmails": "Ezek a sorok olyan e-mail-címet adnak meg, amely senkihez sem tartozik ({{rows}}). Kérjük, vegye fel a személyt a(z) {{peopleSheet}} munkalapra, vagy javítsa a címet.",
      "excelUnlistedLeads": "Ezek a sorok olyan személyt neveznek meg, akit a fájl eltávolít ({{rows}}). Kérjük, vegye fel a személyt a(z) {{peopleSheet}} munkalapra, vagy nevezzen meg más személyt.",
      "excelNoPeople": "A(z) {{sheet}} munkalap nem tartalmaz személyeket.",
      "personioNotLinked": "A Personio nincs csatlakoztatva.",
      "personioCredentialsRejected": "A Personio elutasította a hozzáférési adatokat. Kérjük, ellenőrizze az ügyfél-azonosítót és az ügyfél-titkot.",
      "personioReadFailed": "A Personio nem olvasható be teljesen. Semmi sem változott. Kérjük, próbálja újra később.",
      "personioCredentialsUnreadable": "A tárolt Personio-hozzáférési adatok már nem olvashatók. Kérjük, csatlakoztassa újra a Personiót."
    },
    "capacity": {
      "manualNotApplicable": "Ez a lépés rendszerhez vagy külső kapcsolattartóhoz van rendelve, ezért nem gyűjt kapacitást."
    },
    "survey": {
      "notFound": "Felmérés nem található",
      "notApplicable": "Ez a felmérés nem tartalmaz Önnek szóló kérdést",
      "variantCheckNotApplicable": "Ez a kérdés nem az Ön számára készült",
      "variantDescriptionRequired": "Kérjük, írja le, mit csinál másképp",
      "variantVerdictRequired": "Kérjük, először válaszoljon, hogy ugyanígy végzi-e ezt a lépést",
      "variantAlreadyAnswered": "Erre a felmérésre időközben már válasz érkezett. Kérjük, töltse újra az oldalt.",
      "alreadyDismissed": "Ezt a felmérést már elutasította"
    },
    "entitySuggestion": {
      "notFound": "Javaslat nem található",
      "invalidTransition": "Ez a javaslat nem váltható át ebbe az állapotba",
      "missingAdminField": "Egy csak adminisztrátoroknak fenntartott mező kötelező"
    },
    "insufficientPermissions": "Nincs elegendő jogosultság",
    "totp": {
      "unavailable": "A kétfaktoros hitelesítés nem érhető el a fiókjához.",
      "invalidCode": "A kód érvénytelen. Kérjük, próbálja újra.",
      "alreadyConfigured": "A kétfaktoros hitelesítés már be van állítva. Először távolítsa el az újbóli beállításhoz.",
      "registrationNotFound": "Nem található függőben lévő 2FA-beállítás. Kérjük, kezdje újra a beállítást."
    },
    "passkeys": {
      "unavailable": "A passkey-k nem érhetők el a fiókjához.",
      "lastAuthMethod": "Ez a passkey az utolsó bejelentkezési módja, ezért nem távolítható el. Kérjük, előbb állítson be jelszót vagy egy másik passkey-t."
    },
    "homeOrgMove": {
      "noIdentity": "Ennek a felhasználónak nincs áthelyezhető bejelentkezési identitása.",
      "targetNotSsoEnabled": "A kiválasztott szervezet nem SSO-képes.",
      "noMembershipInTarget": "A felhasználó nem aktív tagja a kiválasztott szervezetnek.",
      "staffRefused": "A munkatársi fiókok nem helyezhetők át másik otthoni szervezetbe.",
      "identityDisabled": "A felhasználó bejelentkezési identitása le van tiltva, ezért nem helyezhető át.",
      "conflict": "A felhasználó bejelentkezési identitása megváltozott az áthelyezés közben. Kérjük, töltse újra az oldalt, és próbálja újra.",
      "emailConflict": "A(z) {{email}} e-mail-címhez tartozó bejelentkezési fiók már egy másik személyhez tartozik.",
      "deadEmailSyncItem": "Ehhez a személyhez egy elakadt e-mail-módosítási szinkronizálási elem tartozik. Kérjük, indítsa újra vagy törölje a szinkronizálási sorban, mielőtt áthelyezné az otthoni szervezetet."
    },
    "signInReset": {
      "notPermitted": "Csak a személy otthoni szervezetének rendszergazdája állíthatja alaphelyzetbe a bejelentkezési adatait.",
      "self": "Saját bejelentkezési adatait nem állíthatja alaphelyzetbe.",
      "userNotActive": "Csak aktív tagok bejelentkezési adatai állíthatók alaphelyzetbe. Függőben lévő meghívás esetén küldje el újra a meghívót.",
      "noHomeOrg": "A személy otthoni szervezete ismeretlen, ezért a bejelentkezési adatai itt nem állíthatók alaphelyzetbe.",
      "homeOrgDeleted": "A személy otthoni szervezetét törölték. A bejelentkezési adatok alaphelyzetbe állítása előtt rendeljen hozzá új otthoni szervezetet.",
      "ssoEnforced": "Ez a személy a szervezete egyszeri bejelentkezésével (SSO) jelentkezik be, ezért a bejelentkezési adatait ott kezelik.",
      "conflict": "A személy bejelentkezési adatai megváltoztak az alaphelyzetbe állítás közben. Kérjük, töltse újra az oldalt, és próbálja újra.",
      "identityDisabled": "A személy bejelentkezése le van tiltva, ezért a bejelentkezési adatai nem állíthatók alaphelyzetbe. Először állítsa vissza a hozzáférését.",
      "emailChangeUnsettled": "Az ehhez a címhez tartozó e-mail-módosítás még nem jutott el a bejelentkezési fiókhoz, ezért a bejelentkezési adatok most nem állíthatók alaphelyzetbe. Kérjük, próbálja újra néhány perc múlva; ha a probléma továbbra is fennáll, forduljon az ügyfélszolgálathoz."
    },
    "stepTemplate": {
      "notFound": "A lépéssablon nem található",
      "invalidSelection": "A kiválasztás olyan elemeket tartalmaz, amelyek nem ehhez a piszkozathoz tartoznak",
      "corrupt": "A lépéssablon hibás, és nem szúrható be"
    },
    "app": {
      "notFoundInRegistry": "Ez az alkalmazás nem érhető el.",
      "notAvailableForTenant": "Ez az alkalmazás nem érhető el az Ön munkaterületén. Kérjük, forduljon a rendszergazdához.",
      "notUnlocked": "Ez az alkalmazás nincs feloldva ehhez a bérlőhöz.",
      "notInstalled": "Ez az alkalmazás nincs telepítve az Ön munkaterületén.",
      "notActive": "Ez az alkalmazás nem aktív az Ön munkaterületén.",
      "fileNotFound": "A fájl nem található",
      "fileTypeUnsupported": "Nem támogatott fájltípus: {{mimeType}}",
      "fileTooLarge": "A fájl nagyobb a megengedett {{maxSizeBytes}} bájtnál.",
      "fileExpired": "Ez a fájl már nem érhető el – a megőrzési ideje lejárt."
    },
    "appChat": {
      "sessionNotFound": "Ez a beszélgetés már nem létezik."
    },
    "omniscient": {
      "exportNotFound": "Az export nem található"
    },
    "transcription": {
      "audioFormatUnsupported": "Nem támogatott hangformátum: {{mimeType}}"
    },
    "chat": {
      "messageNotFound": "Ez az üzenet már nem létezik."
    },
    "account": {
      "parentCycle": "Ez a fiók nem rendelhető önmaga alá.",
      "parentTooDeep": "A csoport túl mélyen ágazik.",
      "companyAlreadyAssigned": "Ez a HubSpot cég már egy másik fiókhoz van rendelve.",
      "partnerCompanyLocked": "Ez a fiók partner-munkaterületet üzemeltet ({{tenantName}}). HubSpot cégét csak az módosíthatja, aki a munkaterületeket kezeli.",
      "notFound": "A fiók nem található."
    },
    "hubspot": {
      "companyNotFound": "Nincs HubSpot-cég ezzel az azonosítóval."
    },
    "superAdmin": {
      "lastAdmin": "Senki sem maradna, aki platformadminisztrátorként bejelentkezhet — és csak ők oszthatnak ki szerepköröket."
    }
  }
}
